<script>
    export let sources = [];

    function newPreload(timeout) {
        let promise = new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve()
            }, timeout)
        });
        return promise;
    }

</script>

<svelte:head>
    {#each sources as link}
        <link rel="preload" href={link.href}>
        {#await newPreload(link.timeout) then value}
            <link rel={link.rel} href={link.href}>
        {/await}
    {/each}
</svelte:head>